export default __webpack_public_path__ + "static/media/Add.e95bf55c.svg";